export enum AccessTypes {
  READ = 'READ',
  WRITE = 'WRITE',
}

export enum STATE {
  INITIAL_STATE = 'INITIAL_STATE',
  TABLE_LOADING = 'TABLE_LOADING',
  TABLE_LOADED = 'TABLE_LOADED',
  CREATE_NEW_CRITERION = 'CREATE_NEW_CRITERION',
  CREATE_NEW_CRITERION_IN_PROGRESS = 'CREATE_NEW_CRITERION_IN_PROGRESS',
  UPDATE_CRITERION = 'UPDATE_CRITERION',
  UPDATE_CRITERION_IN_PROGRESS = 'UPDATE_CRITERION_IN_PROGRESS',
  DELETE_CRITERION = 'DELETE_CRITERION',
  DELETE_CRITERION_IN_PROGRESS = 'DELETE_CRITERION_IN_PROGRESS',
}

export const CRITERION_PER_PAGE = 10;
